import React, { useContext } from 'react';
import { Box, Stack } from '@mui/material';
import { TaskStatusMobile, ButtonTaskResolve, ButtonTaskReject, TaskMessage } from './Task.styled';
import { updateStatus } from 'src/api/assignments/assignments';
import { TAssignment, AssignmentStatus } from 'src/api/assignments/models';
import { TMessageItem } from 'src/api/messages/models';
import { ChatsContext } from 'src/context/chats';
import { RejectionReasonSolving, NoticeOfCriticalValues, MakeAnAppointment } from './TaskTypes';
import { buildDataTestId, buildDataTestIdAttribute, capitalizeOnlyFirstLetter } from 'src/utils/functionHelpers';

type TaskProps = {
  task: TMessageItem;
  isTablet?: boolean;
  isMobile?: boolean;
  dataTestId?: string;
};

enum TaskStatuses {
  'Incomplete' = 'Unresolved',
  'Completed' = 'Resolved',
  'Cancelled' = 'Reject',
}

export const TasksFactory: React.FC<TaskProps> = ({ task, isMobile, dataTestId }) => {
  const { status, assignmentId, assignmentType, fromCurrentModule, title } = task;
  const { activeChat } = useContext(ChatsContext);

  const hanldeResolvedClick = () => {
    void updateStatus({
      assignmentId: assignmentId as string,
      conversationId: activeChat,
      status: AssignmentStatus.Completed,
    });
  };
  const hanldeRejectedClick = () => {
    void updateStatus({
      assignmentId: assignmentId as string,
      conversationId: activeChat,
      status: AssignmentStatus.Cancelled,
    });
  };
  TAssignment.MakeAnAppointment;

  const titleCapitalizedOnlyFirstLetter = title ? capitalizeOnlyFirstLetter(title) : '';

  const renderTask = () => {
    switch (assignmentType) {
      case TAssignment.NoticeOfCriticalValues: {
        return (
          <NoticeOfCriticalValues task={task} dataTestId={buildDataTestId(dataTestId, 'notice-critical-values')} />
        );
      }
      case TAssignment.RejectionReasonSolving: {
        return (
          <RejectionReasonSolving task={task} dataTestId={buildDataTestId(dataTestId, 'rejection-reason-solving')} />
        );
      }
      case TAssignment.MakeAnAppointment: {
        return <MakeAnAppointment task={task} />;
      }
      default: {
        return null;
      }
    }
  };
  return (
    <>
      {isMobile ? (
        <Stack direction="row" justifyContent="space-between">
          <TaskMessage prewrap={1} fontWeight={700} inline={1}>
            {titleCapitalizedOnlyFirstLetter}
          </TaskMessage>
          <TaskStatusMobile>{status && TaskStatuses[status]}</TaskStatusMobile>
        </Stack>
      ) : (
        <TaskMessage
          prewrap={1}
          fontWeight={700}
          inline={0}
          marginBottom={'4px'}
          fontSize="16px"
          color="grey.700"
        >
          {titleCapitalizedOnlyFirstLetter}
        </TaskMessage>
      )}
      {renderTask()}
      {!fromCurrentModule && status === (AssignmentStatus.Incomplete as unknown as string) && (
        <Box sx={{ height: 0, order: -1 }} mt="4px" marginBottom="12px">
          <Stack direction="row" gap="12px">
            <ButtonTaskResolve
              size="small"
              color="secondary"
              variant="contained"
              onClick={hanldeResolvedClick}
              disableRipple
              {...buildDataTestIdAttribute(dataTestId, 'button-resolve')}
            >
              Resolve
            </ButtonTaskResolve>
            {assignmentType !== TAssignment.NoticeOfCriticalValues && (
              <ButtonTaskReject
                disableRipple
                size="small"
                color="secondary"
                variant="outlined"
                onClick={hanldeRejectedClick}
                {...buildDataTestIdAttribute(dataTestId, 'button-reject')}
              >
                Reject
              </ButtonTaskReject>
            )}
          </Stack>
        </Box>
      )}
    </>
  );
};
